<template>
  <div>
    <form v-on:submit="save">
      <div class="card card-info" v-if="screen==='enabled'">
        <div class="card-header with-border">
          <h3 class="card-title">
            New Template
          </h3>
        </div>
        <div class="card-body">
          <div class="row" style="margin-top: 7px">
            <div class="col-md-4">
              <label>Name *</label>
              <input class="form-control" v-model="data.Name" required/>
            </div>

            <div class="col-md-4">
          <br />
          <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" id="customCheckbox1" value="option1" v-model="data.Active">
            <label for="customCheckbox1" class="custom-control-label">Active</label>
          </div>
        </div>
          </div>
          <div class="row" style="margin-top: 5px;">
            <div class="col-md-6">
              <label>Allowences</label>
              <table class="table table-bordered table-color table-sm">
                <thead class="bg-info">
                  <tr>
                    <th style="width: 10px">Sr. #</th>
                    <th style="width: 60%">Name</th>
                    <th style="width: 20%">Amount</th>
                    <th style="width: 10%">Basic</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in SalaryTemplateChild.filter((x) => { return x.Type == 'Allowences'; })">
                    <td>{{ind + 1}}</td>
                    <td>{{item._SalaryHead}}</td>
                    <td>
                      <input class="form-control" v-model="item.Amount" v-mask="'########'" v-on:change="getSum('Allowences')" />
                    </td>
                    <td>
                      <input class="form-check" type="checkbox" v-model="item.IsBasic">
                    </td>
                  </tr>
                </tbody>
                
                <tfoot>
                  <tr>
                    <th colspan="3" style="text-align: center">Total Allowences</th>
                    <th style="text-align: right">{{totalallowence}}</th>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="col-md-6">
              <label>Deductables</label>
              <table class="table table-bordered table-color table-sm" width="100%">
                <thead class="bg-info">
                  <tr>
                    <th style="width: 10px">Sr. #</th>
                    <th style="width: 60%">Name</th>
                    <th style="width: 20%">Amount</th>
                    <th style="width: 10%">Basic</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in  SalaryTemplateChild.filter((x) => { return x.Type == 'Deductables'; })">
                    <td>{{ind + 1}}</td>
                    <td>{{item._SalaryHead}}</td>
                    <td>
                      <input class="form-control" v-model="item.Amount" v-mask="'########'" v-on:change="getSum('Deductables')" />
                    </td>
                    <td>
                      <input class="form-check" type="checkbox" v-model="item.IsBasic">
                    </td> 
                  </tr>
                </tbody>
                
                <tfoot>
                  <tr>
                    <th colspan="3" style="text-align: center">Total Deductables</th>
                    <th style="text-align: right">{{totaldeductable}}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <div class="card-footer"> 
            <button class="btn btn-info float-left" type="button" v-on:click="Back()">Back</button>
            <button class="btn btn-success float-right" type="submit">Save</button> 
        </div>
      </div>
    </form>
    
    <div class="card card-info" v-if="screen==='default'">
      <div class="card-header with-border">
        <h3 class="card-title" style="width: 100%">
          <button v-on:click="add()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
        </h3>
      </div>
      <div class="card-body">

        <div class="row" style="margin-top: 5px;">
          <div class="col-md-12">
            <table id="leavesRecordTable"class="table table-bordered table-sm text-sm" width="100%">
              <thead class="bg-info">
                <tr>
                  <th style="width: 10px">Sr.</th>
                  <th style="width: 40%">Template Name</th> 
                  <th style="width: 10%">Total Allowances</th>
                  <th style="width: 10%">Total Deductables</th>
                  <th style="width: 10%">Net Payable</th>
                  <th>Active</th>
                  <th style="width: 10%">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in data2">
                  <td>{{ind + 1}}</td>
                  <td>{{item.SalaryTemplateName}}</td> 
                  <td>
                    {{item.TotalAllowences}}
                  </td>
                  <td>{{item.TotalDeductables}}</td>
                  <td>{{item.TotalAllowences - item.TotalDeductables}}</td>
                  <td>
                    <input type="checkbox" class="form-check" v-model="item.Active" disabled />
                  </td>
                  <td>
                    <button type="button" class="btn btn-primary" v-on:click="Edit(item.SalaryTemplateID,item.Name,item.Active)">Edit</button>
                  </td>
                </tr>
              </tbody>


            </table>
          </div>


        </div>
      </div>

    </div>
  </div>
</template>

<script>

  function allowOnlyNumber(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  const axios = require('axios').default;

  export default ({
    data() {
      return {
        isupdate: false,
        data: { Name: '', Active: 0, SalaryTemplateID: 0},
        SalaryTemplateChild: [], 
        totalallowence: 0,
        totaldeductable: 0, 
        data2: [],
        btn: 'default',
        screen: 'default',
      }
    },
    created: function () {
      this.loaddata();
    },
    updated: function () {
      $('#leavesRecordTable').DataTable();
    },

    methods: {
      getSum(cat) {
        this.totalallowence = 0;
        this.totaldeductable = 0;
        for (var i = 0; i < this.SalaryTemplateChild.length; i++) {
          if (this.SalaryTemplateChild[i].Type == 'Allowences') {
            this.totalallowence += Number(this.SalaryTemplateChild[i].Amount);
          }
          else {
            this.totaldeductable += Number(this.SalaryTemplateChild[i].Amount);
          }
        }

      },
      clear() {
        this.isupdate = false;
        this.data = { Name: '', Active: '', SalaryTemplateID: 0 }; //SalaryTemplateID: 0,
        this.SalaryTemplateChild = [];
        this.totalallowence = 0;

        this.totaldeductable = 0;
      },
      add() {
        this.screen = "enabled";
        this.loadEmployee();
      },
      loaddata() {
        startReq();
        var vm = this;
        axios.post('/api/PayrollApi/loadtemplatedata')
          .then(function (res) {


            vm.data2 = res.data.EmployeeTemplateChildsss;

          })
          .catch(function (res) {

          });
        endReq();
      },
      save(e) {
        e.preventDefault();
        startReq();
        var vm = this; 
        axios.post('/api/PayrollApi/saveEmployeeSalary2', {
          salary: vm.data,
          salaryChild: vm.SalaryTemplateChild
        })
          .then(function (res) { 
            if (res.data.status) {
              endReq();
              toastr.success("Saved", "Done!");
              vm.clear();
              vm.screen = "default";
              vm.loaddata();
            }
            else {
              toastr.error("Error ", "Done!");
              vm.clear();
            }

          })
          .catch(function (res) {

          });
      },
      loadEmployee() {
        startReq();
        var vm = this;
        axios.post('/api/PayrollApi/loadEmployeebyCode2')
          .then(function (res) {
            if (!res.data.status) {
              toastr.error("No record found", "Error!");
            }
            else {

              vm.SalaryTemplateChild = res.data.EmployeeTemplateChild;
            }
          })
          .catch(function (res) {

          });
        endReq();
      },
      Edit(ID, Name, Active) {
        startReq();
        var vm = this;
        axios.post('/api/PayrollApi/loadEmployeebyCode3?ID=' + ID)
          .then(function (res) {

            vm.data.Name = res.data.data[0].Name;
            vm.SalaryTemplateChild = res.data.data;
            vm.data.SalaryTemplateID = ID;
            vm.data.Active = Active;
            vm.totalallowence = 0;
            vm.totaldeductable = 0;
            for (var i = 0; i < vm.SalaryTemplateChild.length; i++) {
              if (vm.SalaryTemplateChild[i].Type == 'Allowences') {
                vm.totalallowence += Number(vm.SalaryTemplateChild[i].Amount);
              }
              else {
                vm.totaldeductable += Number(vm.SalaryTemplateChild[i].Amount);
              }
            }
            vm.btn = "enabled";
            vm.screen = "enabled";


          })
          .catch(function (res) {

          });
        endReq();
      },
      Back() {
        window.location = "../Payroll/SalaryTemplate";
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/payroll/salaryTemplate.vue